import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReservedSpotRadioButton from './ReservedSpotRadioButton';
import { LOCK_PARKING_GROUP_NAME } from './../../constants';

class SpotsToRemoveOptions extends Component {

  render () {
    const {spotToUnreserve, reservedSpots, qualifiedSpots, attendee} = this.props;

    const attendeeLockedSpots = LOCK_PARKING_GROUP_NAME && attendee.assignments ?
      attendee.assignments.filter((assignment) => assignment.group.toLowerCase() === LOCK_PARKING_GROUP_NAME.toLowerCase()) :
      [];

    const reservedSpotOptionsToRemove = reservedSpots.map((spotName, index) => {
      const isSpotLocked = attendeeLockedSpots.some((lockedSpot) => lockedSpot.vehicleNumber === spotName);
      return <ReservedSpotRadioButton key={index} spotName={spotName} spotToUnreserve={spotToUnreserve} isLocked={isSpotLocked} />;
    });

    return (
      <div className="form-group">
        {((!spotToUnreserve && (reservedSpots.length > 0) ) || (spotToUnreserve && (reservedSpots.length > 1))) &&
        (<label htmlFor=""><i className="fa fa-warning color-warning"/>&nbsp;
          Please select which spot to remove
        </label>)
        }

        {(qualifiedSpots > 1) && reservedSpotOptionsToRemove}
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    spotToUnreserve: state.checkout.spotToUnreserve,
    reservedSpots: state.userAccommodationInfo.reservedSpots,
    qualifiedSpots: state.userAccommodationInfo.qualifiedSpots,
    attendee: state.userAccommodationInfo.attendee,
  };
};

export default connect(mapStateToProps)(SpotsToRemoveOptions);



// WEBPACK FOOTER //
// ./src/containers/checkout/SpotsToRemoveOptions.js